import { useEffect } from 'react';

export default function TermsPage() {
  useEffect(() => {
    window.location.href = '/terms';
  }, []);

  return null;
}
